const problems = [
  {
    icon: 'ri-flag-line',
    title: 'Разные цели',
    desc: 'Каждый сотрудник работает на свой результат, а не на общий. Отделы конкурируют за ресурсы и внимание руководства, а не сотрудничают.',
  },
  {
    icon: 'ri-shield-cross-line',
    title: 'Нет доверия',
    desc: 'Сотрудники не готовы делиться информацией, признавать ошибки и просить помощь. Вместо открытости — подозрительность и осторожность.',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Отделы конкурируют',
    desc: 'Продажи обвиняют логистику, логистика — производство, все вместе — руководство. Внутри компании идет война, а не совместная работа.',
  },
  {
    icon: 'ri-chat-off-line',
    title: 'Слабая коммуникация',
    desc: 'Информация искажается при передаче, решения принимаются без обсуждения, важные детали теряются между отделами.',
  },
  {
    icon: 'ri-emotion-unhappy-line',
    title: 'Конфликты',
    desc: 'Межличностные трения, разногласия по процессам, борьба за влияние — все это отнимает энергию и снижает производительность.',
  },
  {
    icon: 'ri-user-unfollow-line',
    title: 'Размытая ответственность',
    desc: 'Никто не берет на себя ответственность за общий результат. Задачи перекладываются, сроки срываются, а проблемы остаются нерешенными.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Низкая вовлеченность',
    desc: 'Сотрудники выполняют минимум, не предлагают идей и не стремятся улучшить результат. Работа воспринимается как обязанность, а не как общее дело.',
  },
];

export default function WhyGoodEmployeesDontMakeTeam() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему хорошие сотрудники не становятся автоматически хорошей командой
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Нанять талантливых специалистов недостаточно. Если между ними нет доверия, коммуникации и общих правил — это просто группа людей, а не команда.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {problems.map((p, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 hover:bg-gray-100 transition-colors group">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${p.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{p.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Инфографика цепочки проблем */}
        <div className="mt-16 bg-gradient-to-r from-teal-50/70 to-gray-50 rounded-2xl p-8 md:p-12 border border-teal-100/40">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 text-center mb-8">
            Что происходит без командообразования
          </h3>
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-0">
            {[
              { label: 'Стресс', color: 'bg-teal-400' },
              { label: 'Конфликты', color: 'bg-teal-500' },
              { label: 'Ошибки', color: 'bg-teal-600' },
              { label: 'Низкая эффективность', color: 'bg-teal-700' },
              { label: 'Увольнения', color: 'bg-teal-800' },
            ].map((item, i, arr) => (
              <div key={i} className="flex items-center">
                <div className={`${item.color} text-white px-5 py-3 rounded-xl font-bold text-sm md:text-base whitespace-nowrap`}>
                  {item.label}
                </div>
                {i < arr.length - 1 && (
                  <>
                    <i className="ri-arrow-down-line md:hidden text-teal-400 text-xl mx-1"></i>
                    <i className="ri-arrow-right-line hidden md:inline text-teal-400 text-xl mx-2"></i>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}